import ApiService from './ApiService';

export default class InquiryApi extends ApiService {
    constructor() {
        super('');
    }

    // #region CMS
    getInquiries(payload) {
        return this.get('system/inquiry', payload);
    }

    getInquiry(id) {
        return this.get(`system/inquiry/${id}`);
    }

    updateInquiry(data) {
        const { id, payload } = data;
        return this.put(`system/inquiry/${id}`, payload);
    }

    deleteInquiry(id) {
        return this.delete(`system/inquiry/${id}`);
    }
    // #endregion

    // #region Enduser
    createInquiry(payload) {
        return this.post('inquiry', payload);
    }
    // #endregion
}
